function FeedbackThanks() {
    return <>
        <div className="container-fluid">
            <div className="text-center mt-3 fs-2">
                Thank you for your valuable feedback! <br />We truly appreciate you taking the time to share your thoughts with us.
            </div>
        </div>

    </>
}

export default FeedbackThanks;